import type { PageHelp } from "../../help/types";
import {
  DOCUMENTS_CONTEXTS,
  DOCUMENTS_DIALOG,
  LIST_VIEW_CONTEXT,
  PACKAGE_DIALOG_DETAILS,
  PACKAGE_DIALOG_RULES,
  PACKAGES_CARD_ACTIONS,
  PACKAGES_GETTING_AROUND,
  PACKAGES_LIST_VIEW,
  PACKAGES_READING_CARDS,
  PACKAGES_TOOLBAR,
  documentsDialogSteps,
  packageCardActionSteps,
  packageCardSteps,
  packageDialogSteps,
  packageListSteps,
  packagesFindSteps,
  packagesToolbarSteps,
} from "../CompanyPackagesPage/help-steps";

export const hrPackagesPageHelp: PageHelp = {
  title: "Benefit packages (HR)",
  intro:
    "The packages of one benefit implementation, opened from an implementation card on the HR page. Use it to check what each package costs and who is eligible, and to go on to the employees of a package. Admin roles can also add and edit packages here; HR roles see them read-only.",
  sections: [
    PACKAGES_GETTING_AROUND,
    PACKAGES_TOOLBAR,
    PACKAGES_READING_CARDS,
    PACKAGES_CARD_ACTIONS,
    PACKAGES_LIST_VIEW,
    PACKAGE_DIALOG_DETAILS,
    PACKAGE_DIALOG_RULES,
    DOCUMENTS_DIALOG,
  ],
  contexts: {
    "list-view": LIST_VIEW_CONTEXT,
    "package-dialog":
      'Click "Add Package" in the toolbar, or the edit icon on a package card or table row (admin roles only).',
    "package-dialog-add": 'Click "Add Package" in the toolbar (admin roles only).',
    "package-dialog-edit":
      "Click the edit icon on a package card or table row (admin roles only).",
    "documents-dialog":
      'Click the documents icon on a package card, or "Manage Documents" / "Add Documents" in a table row or in the package dialog (admin roles only).',
    ...DOCUMENTS_CONTEXTS,
  },
  tips: [
    "To work with the people in a package, open its employees: double-click the card picture in grid view, or use the people icon on the card or table row if your role shows it.",
    "HR roles cannot change packages. Ask your GrECo contact when a price, payment split or eligibility rule needs to change.",
    "Grid view (cards) is the default. List view is chosen in the settings menu (gear icon in the header).",
  ],
  steps: [
    {
      selector: '[data-help="packages-breadcrumb"]',
      section: PACKAGES_GETTING_AROUND,
      title: "Go back to the HR page",
      body: 'The "HR" breadcrumb returns to the HR page, where the implementation cards and the employee list of the selected company are.',
    },
    ...packagesFindSteps,
    ...packagesToolbarSteps,
    {
      selector: '[data-help="benefit-card"]',
      section: PACKAGES_READING_CARDS,
      optional: true,
      title: "Read a package card",
      body: "Each card is one package: picture, name with the age range if one is set, and description (hover to read it in full). Double-click the picture to open the employees of the package; this works for every role.",
    },
    ...packageCardSteps,
    {
      selector: '[data-help="benefit-card-open"]',
      section: PACKAGES_CARD_ACTIONS,
      optional: true,
      minRole: "admin",
      title: "Open the employees of a package",
      body: 'The people icon ("Open Package Employees") opens the page with the employees of this package. Roles without the card footer double-click the card picture instead.',
    },
    ...packageCardActionSteps,
    ...packageListSteps,
    {
      selector: '[data-help="package-row-employees"]',
      section: PACKAGES_LIST_VIEW,
      context: "list-view",
      optional: true,
      title: "Open the employees of a row",
      body: 'The people icon at the start of the Actions cell opens the employees of the package. It is disabled for read-only and HR roles; they switch to grid view and double-click the card picture instead.',
    },
    ...packageDialogSteps,
    ...documentsDialogSteps,
  ],
};
